module.exports = __webpack_public_path__ + "img/my-type-pay.464806ab.png";